var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BusinessCrud',{attrs:{"title":"积分产品","columns":_vm.columns,"search-fields":_vm.searchFields,"form-fields":_vm.formFields,"list-api":_vm.getPointsGiftList,"save-api":_vm.savePointsGift,"delete-api":_vm.deletePointsGift,"defaults":{ giftCategory: '实物', coverImage: '', pointsPrice: 0, stock: 0, limitQuantity: 1, sortOrder: 0, status: 1 }}})
}
var staticRenderFns = []

export { render, staticRenderFns }